export { Heading6 } from "./Heading6";
